(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wpw-sale-preview"] && !Shopify.designMode) return;
  try {
    const pad = (value) => String(value).padStart(2, '0');

  const remainingMs = (now, startedAt, durationMs) => {
    if (!Number.isFinite(startedAt) || startedAt <= 0 || durationMs <= 0) return durationMs;
    const elapsed = Math.max(0, now - startedAt);
    const leftover = elapsed % durationMs;
    return leftover === 0 && elapsed > 0 ? durationMs : durationMs - leftover;
  };

  const readStart = (key, now) => {
    try {
      const raw = window.localStorage.getItem(key);
      const startedAt = Number(raw);
      if (Number.isFinite(startedAt) && startedAt > 0) return startedAt;
    } catch (error) {
      // Private mode can block storage; fall through to a fresh cycle.
    }
    try {
      window.localStorage.setItem(key, String(now));
    } catch (error) {
      // Keep a page-local start if storage is unavailable.
    }
    return now;
  };

  class WpwFlashCountdown extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound === 'true') return;
      this.dataset.bound = 'true';
      this.durationMs = Number(this.dataset.durationMinutes) * 60 * 1000;
      this.storageKey = this.dataset.storageKey;
      this.hoursEl = this.querySelector('[data-unit="hours"]');
      this.minutesEl = this.querySelector('[data-unit="minutes"]');
      this.secondsEl = this.querySelector('[data-unit="seconds"]');
      this.startedAt = readStart(this.storageKey, Date.now());
      this.render(Date.now());
      this.timerId = window.setInterval(() => this.render(Date.now()), 1000);
    }

    disconnectedCallback() {
      if (this.timerId) window.clearInterval(this.timerId);
    }

    render(now) {
      let leftover = remainingMs(now, this.startedAt, this.durationMs);
      if (leftover <= 0) leftover = this.durationMs;
      const totalSeconds = Math.floor(leftover / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      if (this.hoursEl) this.hoursEl.textContent = pad(hours);
      if (this.minutesEl) this.minutesEl.textContent = pad(minutes);
      if (this.secondsEl) this.secondsEl.textContent = pad(seconds);
    }
  }

  if (!customElements.get('wpw-flash-countdown')) {
    customElements.define('wpw-flash-countdown', WpwFlashCountdown);
  }
  } catch(e) { console.error(e); }
})();

})();
